export enum QueryParameters {
  Portal = "portal",
  Payment = "payment",
  PaymentPlan = "paymentPlan",
  Plan = "plan",
  RedirectTo = "redirect_to",
}

export enum Portals {
  Kells = "kells",
  Aetna = "aetna",
  Beanstalk = "beanstalk",
  Lantnerdds = "lantnerdds",
  AYG = "ayg",
  DentalSavers = "dentalsavers",
  OralLink = "orallink",
  Schoolconomy = "schoolconomy",
  UCA = "uca",
  AsiaMedic = "asiamedic",
  Benefitsiq_d2c = "benefitsiq-d2c",
  AYG_d2c = "ayg-d2c",
  Thatch = "thatch",
  Paychex = "paychex",
  Corestream = "corestream",
  AJG = "ajg",
}

export const portalsOrganizations = [
  {
    portal: Portals.Kells,
    organizationName: "Kells",
  },
  {
    portal: Portals.Aetna,
    organizationName: "Aetna",
  },
  {
    portal: Portals.Beanstalk,
    organizationName: "Beanstalk Benefits",
  },
  {
    portal: Portals.Lantnerdds,
    organizationName: "Lantnerdds",
  },
  {
    portal: Portals.AYG,
    organizationName: "Ayg",
  },
  {
    portal: Portals.DentalSavers,
    organizationName: "Dentalsavers",
  },
  {
    portal: Portals.OralLink,
    organizationName: "OralLink",
  },
  {
    portal: Portals.Schoolconomy,
    organizationName: "Schoolconomy",
  },
  {
    portal: Portals.UCA,
    organizationName: "Unified Caring Association",
  },
  {
    portal: Portals.AsiaMedic,
    organizationName: "Asia Medic",
  },
  {
    portal: Portals.Benefitsiq_d2c,
    organizationName: "BenefitsIQ",
  },
  {
    portal: Portals.AYG_d2c,
    organizationName: "AYG D2C",
  },
  {
    portal: Portals.Thatch,
    organizationName: "Thatch",
  },
  {
    portal: Portals.Paychex,
    organizationName: "Paychex",
  },
  {
    portal: Portals.Corestream,
    organizationName: "Corestream",
  },
  {
    portal: Portals.AJG,
    organizationName: "Gallagher",
  },
];
